export default __webpack_public_path__ + "static/loyalty-and-rewards-solutions-574b584ee3f904d1a2945c295d528d39.png";